package org.solyton.solawi.bid.application.`data`.version.full

import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.application.`data`.version.VersionInfo

/**
 * Autogenerated Lens.
 * Read and manipulate [FullVersionInfo.backend]
 */
@ReadWrite
public val backend: Lens<FullVersionInfo, VersionInfo> by lazy {
      Lens(
        get = { whole -> whole.backend },
        set = { part -> { whole -> whole.copy(backend = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [FullVersionInfo.backend]
 */
@ReadWrite
public fun FullVersionInfo.backend(`set`: VersionInfo.() -> VersionInfo): FullVersionInfo =
    copy(backend = set(backend))

/**
 * Autogenerated Lens.
 * Read and manipulate [FullVersionInfo.frontend]
 */
@ReadWrite
public val frontend: Lens<FullVersionInfo, VersionInfo> by lazy {
      Lens(
        get = { whole -> whole.frontend },
        set = { part -> { whole -> whole.copy(frontend = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [FullVersionInfo.frontend]
 */
@ReadWrite
public fun FullVersionInfo.frontend(`set`: VersionInfo.() -> VersionInfo): FullVersionInfo =
    copy(frontend = set(frontend))
